<pr-page-splash>
  <pt-register
    logoSrc="/assets/icons/principle-row-dark.png"
    [name]="name$ | async"
    [email]="email$ | async"
  />
</pr-page-splash>
